var PropTypes = require('prop-types');
let React = require('react');
let ReactDOMServer = require('react-dom/server');
let Notification = require('./notification.jsx');

// Libs
let events = require('../../lib/events.js');

class NotificationBar extends React.Component {
  static propTypes = {
    debugMode: PropTypes.bool.isRequired,
  };

  state = {
    notifications: [],
  };

  componentDidMount() {
    this._errorCaughtHTTP = events.subscribe('http-error', data => {
      if (data.xhr.status !== 401) {
        let httpError = <span>Oops! looks like we had a server error. The issue has been logged and we are looking into it.
            (<a href={data.xhr.responseURL} target='_NEW'>URL</a>)
        </span>;

        this.state.notifications.push({
          message: httpError,
          extraClasses: 'error',
        });
        while (this.state.notifications.length > 10) {
          this.state.notifications.shift();
        }
        this.setState({notifications: this.state.notifications});
      }
    });

    this._errorCaught = events.subscribe('error.user', data => {
      let duplicates = this.state.notifications.filter(x => {
        if (data.message.props && x.message.props) {
          return ReactDOMServer.renderToString(x.message) === ReactDOMServer.renderToString(data.message) && x.extraClasses === 'error';
        }
        return x.message === data.message && x.extraClasses === 'error';
      });

      if (duplicates.length === 0) {
        this.state.notifications.push({
          message: data.message,
          key: data.key,
          extraClasses: 'error',
        });
        while (this.state.notifications.length > 10) {
          this.state.notifications.shift();
        }
        this.setState({notifications: this.state.notifications});
      }
    });

    this._errorCanceled = events.subscribe('cancel.error', data => {
      this.setState({
        notifications: this.state.notifications.filter(x => !x.key || x.key !== data.key),
      });
    }),

    this._warnCaught = events.subscribe('warn.user', data => {
      let duplicates = this.state.notifications.filter(x => {
        if (data.message.props && x.message.props) {
          return ReactDOMServer.renderToString(x.message) === ReactDOMServer.renderToString(data.message) && x.extraClasses === 'warning';
        }
        return x.message === data.message && x.extraClasses === 'warning';
      });

      if (duplicates.length === 0) {
        this.state.notifications.push({
          message: data.message,
          extraClasses: 'warning',
        });
        while (this.state.notifications.length > 10) {
          this.state.notifications.shift();
        }
        this.setState({notifications: this.state.notifications});
      }
    });

    this._infoCaught = events.subscribe('info.user', data => {
      this.state.notifications.push({
        message: data.message,
      });
      while (this.state.notifications.length > 10) {
        this.state.notifications.shift();
      }
      this.setState({notifications: this.state.notifications});
    });

    this._successCaught = events.subscribe('success.user', data => {
      this.state.notifications.push({
        message: data.message,
        icon: 'bl-checkmark blue',
        extraClasses: 'success',
      });
      while (this.state.notifications.length > 10) {
        this.state.notifications.shift();
      }
      this.setState({notifications: this.state.notifications});
    });

    this._eventPagechange = events.subscribe('page-change', () => {
      this.setState({notifications: []});
    });
  }

  componentWillUnmount() {
    this._errorCaughtHTTP.remove();
    this._errorCaught.remove();
    this._warnCaught.remove();
    this._infoCaught.remove();
    this._successCaught.remove();
    this._eventPagechange.remove();
    this._errorCanceled.remove();
  }

  _errorCaught = null;

  _errorCaughtHTTP = null;
  _infoCaught = null;
  _successCaught = null;

  _warnCaught = null;

  closeNotification = (index) => {
    this.state.notifications.splice(index, 1);
    this.setState({notifications: this.state.notifications});
  };

  render() {
    let notifications = this.state.notifications.map((n, i) => {
      return <Notification key={i} index={i}
                title={n.title} message={n.message} icon={n.icon} extraClasses={n.extraClasses}
                debugMode={true} handleClose={this.closeNotification} />;
    });

    return (
      <div>
        {/* Note this is tied to the nav-bar-height property in the sass files. If you update one you must update the other!*/}
        <div className='notification-bar'>
          {notifications}
        </div>
        {/* <div style={{height: 54 * this.state.notifications.length, width: '100%'}} /> */}
      </div>
    );
  }
}

module.exports = NotificationBar;
